import React, { Component } from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import { Button, Card, Form, notification, Popconfirm, Tabs, Tooltip } from 'antd'
import { TableComp, FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request, { API_URL, LAPI_URL } from '../../request'
import moment from 'moment'
import _ from 'lodash'

import { RightsWrapper } from '../../components/_utils/utils'
const TabPane = Tabs.TabPane

@Form.create()

class AllInvoiceSettings extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    docObject: {},
    allTaxes: [],
  }
  handleSubmit = e => {
    const { dispatch, form } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = await Request.addCommunicationSettings(values)

        if (!x.error) {
          notification.success({
            message: `Setting Updated Successfully`
          })
          this.getCommunicationSettings()
        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }
  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }
  refreshFxn = () => {
    this.setState({ refreshChild: !this.state.refreshChild })
  }

  getCommunicationSettings() {
    Request.getCommunicationSettings().then(
      ({ doc, error, message }) => {
        if (!error && doc) {
          this.props.form.setFieldsValue({
            invoiceNumberPrefix: doc.invoiceNumberPrefix || '',
            finalInvoiceNumberStart: doc.finalInvoiceNumberStart || '',
            performaInvoiceNumberPrefix: doc.performaInvoiceNumberPrefix || '',
            groupedPerformaInvoiceNumberPrefix: doc.groupedPerformaInvoiceNumberPrefix || '',
            invoiceBranchNumberPrefix: doc.invoiceBranchNumberPrefix || '',
            financeEmail: doc.financeEmail || '',
            corporateOffice: doc.corporateOffice || '',
            registeredOffice: doc.registeredOffice || '',

            // 🔴 IMPORTANT FIXES
            signWithStamp: Array.isArray(doc.signWithStamp) ? doc.signWithStamp : [],
            headerLogo: Array.isArray(doc.headerLogo) ? doc.headerLogo : [],

            defaultTaxType: doc.defaultTaxType || '',
            defaultTaxTypeintra: doc.defaultTaxTypeintra || '',
          })
          this.setState({ docObject: doc });
        } else {
          // notification.error({
          //   message: 'Error Getting Data',
          //   description: message
          // })
        }
      }
    )
  }

  componentWillMount() {
    this.getCommunicationSettings()
  }

  getAllTaxes = async () => {
    let params = {
      results: 10000,
      count: 10000
    };

    try {
      const resp = await Request.getTaxDetails({ ...params });

      const data = resp.data.reduce((temp, vv) => {
        temp.push({ _id: vv._id, display: vv.taxTitle });
        return temp;
      }, []);

      this.setState({ allTaxes: data });

    } catch (error) {
      console.error("Error fetching tax details:", error);
    }
  };


  async componentDidMount() {
    this.getAllTaxes();
  }

  constructor(props) {
    super(props)
  }
  chooseTab(value) {
    this.setState({
      activeTab: value
    });
    let doc = this.state.docObject;
    setTimeout(() => {
      this.props.form.setFieldsValue({
        invoiceNumberPrefix: doc.invoiceNumberPrefix ? doc.invoiceNumberPrefix : '',
        finalInvoiceNumberStart: doc.finalInvoiceNumberStart ? doc.finalInvoiceNumberStart : '',
        performaInvoiceNumberPrefix: doc.performaInvoiceNumberPrefix ? doc.performaInvoiceNumberPrefix : '',
        groupedPerformaInvoiceNumberPrefix: doc.groupedPerformaInvoiceNumberPrefix ? doc.groupedPerformaInvoiceNumberPrefix : '',
        invoiceBranchNumberPrefix: doc.invoiceBranchNumberPrefix ? doc.invoiceBranchNumberPrefix : '',
        financeEmail: doc.financeEmail ? doc.financeEmail : '',
        corporateOffice: doc.corporateOffice ? doc.corporateOffice : '',
        registeredOffice: doc.registeredOffice ? doc.registeredOffice : '',
        signWithStamp: doc.signWithStamp ? doc.signWithStamp : '',
        headerLogo: doc.headerLogo ? doc.headerLogo : '',
        defaultTaxType: doc.defaultTaxType ? doc.defaultTaxType : '',
        defaultTaxTypeintra: doc.defaultTaxTypeintra ? doc.defaultTaxTypeintra : '',
      })
    }, 1000)
  }
  render() {
    const { dispatch } = this.props
    const {
      form: { getFieldDecorator, setFieldsValue }
    } = this.props
    const { id, allTaxes } = this.state;

    const invoiceSettingInputTypes = {
      fields: [
        {
          label: 'Performa Invoice Prefix',
          key: 'performaInvoiceNumberPrefix'
        },
        // {
        //   label: 'Grouped Performa Invoice Prefix',
        //   key: 'groupedPerformaInvoiceNumberPrefix'
        // },
        {
          label: 'Final Invoice Prefix',
          key: 'invoiceNumberPrefix'
        },
        {
          label: 'Final Invoice Number Start Value',
          key: 'finalInvoiceNumberStart'
        },
        // {
        //   label: 'Invoice Branch Prefix',
        //   key: 'invoiceBranchNumberPrefix'
        // },
        {
          label: 'Finance Email',
          key: 'financeEmail'
        },
        {
          label: 'Corporate Office Address',
          key: 'corporateOffice',
          type: 'editor'
        },
        {
          label: 'Registered Office Address',
          key: 'registeredOffice',
          type: 'editor'
        },
        {
          label: 'Sign With Stamp',
          key: 'signWithStamp',
          type: 'file'
        },
        {
          label: 'Header Logo',
          key: 'headerLogo',
          type: 'file'
        },
        {
          label: 'Footer Logo',
          key: 'footerLogo',
          type: 'file'
        },
        // {
        //   label: 'Default Tax Type Inter',
        //   key: 'defaultTaxType',
        //   type: 'select',
        //   options: allTaxes,
        //   onChange: v => {
        //     this.props.form.setFieldsValue({ defaultTaxType: v });
        //   }
        // },
        // {
        //   label: 'Default Tax Type Intra',
        //   key: 'defaultTaxTypeintra',
        //   type: 'select',
        //   options: allTaxes,
        //   onChange: v => {
        //     this.props.form.setFieldsValue({ defaultTaxTypeintra: v });
        //   }
        // }
      ]
    };

    return (
      <PageHeaderWrapper title={` Invoice Settings `}>
        <Card bordered={true}>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={'Invoice Settings'} key={0}>
              <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                <GetAllFormFields
                  inputSchema={invoiceSettingInputTypes}
                  apiurl={LAPI_URL}
                  refresh={this.refreshFxn}
                  getFieldDecorator={getFieldDecorator}
                />
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.props.loading}
                >
                  SAVE
                </Button>
                <Button
                  type="primary"
                  style={{ marginBottom: 10, marginLeft: '1%' }}
                  loading={this.props.loading}
                  onClick={() => {
                    this.props.form.resetFields()
                  }}>
                  RESET
                </Button>
              </Form>
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllInvoiceSettings
